import Heading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import SharedLottieAsset from '@zenbusiness/zui/SharedLottieAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { FocusGrid, ContainerGrid } from '#client/components/Grid';

import { Wrapper } from '../ApplicationSubmissionModal.styles';

const StatusLoader = ({ children, text, title, src, isStatic }) => (
  <ContainerGrid>
    <FocusGrid>
      <Wrapper>
        <Stack alignItems="center">
          {isStatic ? (
            <SharedAsset
              alt=""
              height={224}
              src={src}
              width={280}
            />
          ) : (
            <SharedLottieAsset
              height={224}
              src={src}
              width={280}
            />
          )}
        </Stack>
        <Heading
          align="center"
          color="primary"
          gutterBottom
          size="3xl"
          weight="bold"
        >
          {title}
        </Heading>
        <Text
          align="center"
          color="tertiary"
          size="lg"
        >
          {text}
        </Text>
      </Wrapper>
    </FocusGrid>
    {children}
  </ContainerGrid>
);

StatusLoader.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  isStatic: PropTypes.bool
};

export default StatusLoader;
